import classNames from "classnames";

import { AscRankItemSizes } from "@ascendnow/shared";

import styles from "./AscRankSign.module.scss";
import {
  FirstPlaceBadgeWhite,
  SecondPlaceBadgeWhite,
  ThirdPlaceBadgeWhite,
  FirstPlaceBadge,
  SecondPlaceBadge,
  ThirdPlaceBadge,
} from "../AscIllustrations";

export interface AscRankSignProps {
  rank: number;
  size?: AscRankItemSizes;
  className?: string;
}

export default function AscRankSign({
  rank,
  size,
  className,
}: AscRankSignProps) {
  return (
    <div
      data-testid="asc-rank-sign"
      className={classNames(styles.ground, className)}
    >
      {rank === 1 &&
        (size === "large" ? (
          <FirstPlaceBadgeWhite
            className={styles.rankSign}
            data-testid={"test-badge"}
          />
        ) : (
          <FirstPlaceBadge className={styles.rankSign} />
        ))}
      {rank === 2 &&
        (size === "large" ? (
          <SecondPlaceBadgeWhite className={styles.rankSign} />
        ) : (
          <SecondPlaceBadge className={styles.rankSign} />
        ))}
      {rank === 3 &&
        (size === "large" ? (
          <ThirdPlaceBadgeWhite className={styles.rankSign} />
        ) : (
          <ThirdPlaceBadge className={styles.rankSign} />
        ))}
      {rank > 3 && rank}
    </div>
  );
}
